<mat-form-field
    [ngClass]="[property.isValid ? 'valid' : 'invalid']"
    attr.data-cy="filter-input-autocomplete-{{ property.Key }}"
    class="select-filter"
>
    <span
        matPrefix
        *ngIf="!property.isLoaded || property.isLoading"
        ><mat-spinner [diameter]="15"></mat-spinner
    ></span>
    <span
        matPrefix
        class="m-r-5"
        *ngIf="property.hasIcon && ((property.isLoaded && !property.isLoading) || !property.isAsync)"
    >
        <i class="{{ property.iconClass }}"></i>
    </span>
    <mat-label>{{ property.displayKey ? property.defaultName + ' ' + property.Key : '' }} </mat-label>
    <input
        type="text"
        [placeholder]="property.placeholder"
        matInput
        [disabled]="disabled ? disabled : null"
        [(ngModel)]="property.Value"
        (ngModelChange)="property.filter()"
        [matAutocomplete]="autocompleteFilter"
        [errorStateMatcher]="errorStateMatcher"
        aria-label="{property.Key}"
    />

    <span
        matSuffix
        class="suffix-reset-btn"
        *ngIf="property.onReset"
    >
        <app-button
            [icon]="'fa-solid fa-xmark'"
            [type]="'icon'"
            (buttonClick)="onReset($event)"
        >
        </app-button>
    </span>

    <mat-autocomplete
        [class]="'ag-custom-component-popup autocomplete-overlay'"
        #autocompleteFilter="matAutocomplete"
        [panelWidth]="280"
        id="{{ property.Key }}"
        [aria-label]="property.defaultName + ' ' + property.Key"
        (opened)="openedChange()"
        (closed)="closedChange()"
        [displayWith]="displayFn"
    >
        <ng-container *ngIf="(property.filteredOptions | async)?.length">
            <mat-option
                *ngFor="let option of property.filteredOptions | async"
                [value]="option"
            >
                {{ option | displayText }}
            </mat-option>
        </ng-container>
    </mat-autocomplete>
    <mat-hint>{{ property.hint }}</mat-hint>
    <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
</mat-form-field>
